export enum SocialMediumTypes {
  FACEBOOK = "facebook",
  GOOGLE = "google",
}
